import type { FormSegment } from '../../../../../../../../modules/audiences/AudienceForm/types.ts';

type Range = {
  min?: number;
  max?: number;
};

export const segmentsToRangeGroups = (ageSegments?: FormSegment[]): Range[] => {
  if (!ageSegments?.length) {
    return [];
  }

  const ages = ageSegments.map(segment => Number(segment.name)).sort((a, b) => a - b);

  const result: number[][] = [];
  let temp: number[] = [ages[0]];

  for (let i = 1; i < ages.length; i++) {
    if (ages[i] - ages[i - 1] > 1) {
      result.push(temp);
      temp = [];
    }
    temp.push(ages[i]);
  }

  result.push(temp);

  const rangeGroups = result.map(group => ({ min: Math.min(...group), max: Math.max(...group) }));

  return rangeGroups;
};

export const getAgeRange = ({ min, max }: { min?: number; max?: number }) => `${min || 'Any'} - ${max || 'Any'}`;
